module.exports = __webpack_public_path__ + "static/media/Logo_Trust_NWAS.0735ac75.png";